// 手机买门票
const dyRoutes = Array.from({ length: 23 }, (_, i) => ({
  path: `admissionFee/dy/index${i + 1}`,
  name: `admissionFee/dy/Index${i + 1}`,
  component: () => import(`@/views/travel/admissionFee/dy/index${i + 1}.vue`)
}))
const branchDyRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `admissionFee/dy/branch/index${i + 1}`,
  name: `admissionFee/dy/branch/Index${i + 1}`,
  component: () => import(`@/views/travel/admissionFee/dy/branch/index${i + 1}.vue`)
}))
const mtRoutes = Array.from({ length: 16 }, (_, i) => ({
  path: `admissionFee/mt/index${i + 1}`,
  name: `admissionFee/mt/Index${i + 1}`,
  component: () => import(`@/views/travel/admissionFee/mt/index${i + 1}.vue`)
}))
const branchMtRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `admissionFee/mt/branch/index${i + 1}`,
  name: `admissionFee/mt/branch/Index${i + 1}`,
  component: () => import(`@/views/travel/admissionFee/mt/branch/index${i + 1}.vue`)
}))
const xcRoutes = Array.from({ length: 19 }, (_, i) => ({
  path: `admissionFee/xc/index${i + 1}`,
  name: `admissionFee/xc/Index${i + 1}`,
  component: () => import(`@/views/travel/admissionFee/xc/index${i + 1}.vue`)
}))
const branchXcRoutes = Array.from({ length: 10 }, (_, i) => ({
  path: `admissionFee/xc/branch/index${i + 1}`,
  name: `admissionFee/xc/branch/Index${i + 1}`,
  component: () => import(`@/views/travel/admissionFee/xc/branch/index${i + 1}.vue`)
}))

import admissionFeeIndex from '@/views/travel/admissionFee/index'



export default {
  path: '/travel',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'admissionFee/index',
        name: 'admissionFeeIndex',
        component: admissionFeeIndex
      },
    // 手机买门票，开始
    ...dyRoutes,
    ...branchDyRoutes,
    ...mtRoutes,
    ...branchMtRoutes,
    ...xcRoutes,
    ...branchXcRoutes,
    // 手机买门票，结束


  ],
};
